export const formatPrice = (value) => {
  const num = Number(value);

  if (!isFinite(num)) return "0.00";

  return new Intl.NumberFormat("sr-Latn-RS", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

export const formatDate = (date) => {
  if (!date) return "";

  const d = new Date(date);

  return d.toLocaleDateString("sr-Latn-RS", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const formatDateTime = (date) => {
  if (!date) return "";

  const d = new Date(date);

  return d.toLocaleDateString("sr-Latn-RS", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatTime = (date) => {
  if (!date) return "";
  const d = new Date(date);
  return d.toLocaleTimeString("sr-Latn-RS", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const setDateTime = (date, slotValue) => {
  const newDate = new Date(date);
  const hours = Math.floor(slotValue);
  const minutes = slotValue % 1 !== 0 ? 30 : 0;

  newDate.setHours(hours);
  newDate.setMinutes(minutes);
  newDate.setSeconds(0);
  newDate.setMilliseconds(0);

  return newDate;
};

export const formatDuration = (duration) => {
  if (duration < 60) return `${duration}min`;
  const hours = Math.floor(duration / 60);
  const minutes = duration % 60;
  return minutes > 0 ? `${hours}h ${minutes}min` : `${hours}h`;
};

export const formatList = (text) => {
  if (!text) return "";

  // Ukloni breakove
  const clean = text.replace(/\r?\n/g, "");

  // Podeli na delove koji počinju sa "-"
  const parts = clean.split("-");

  // Prvi deo je opis pre liste
  const firstPart = parts.shift().trim();

  // Ostale stavke formatiramo
  const formattedItems = parts
    .map((item) => item.trim())
    .filter(Boolean)
    .map((item, index) => {
      if (index === 0) {
        return `<i>${item}</i>`;
      }
      return `, <i>${item}</i>`;
    })
    .join("");

  return `${firstPart} ${formattedItems}`;
};
